const {store, AoflElement} = aofljs;
/**
 * @summary CdivHeader
 * @class CdivHeader
 * @extends {AoflElement}
 */
class CdivHeader extends AoflElement {
  /**
   * Creates an instance of CdivHeader.
   * @memberof CdivHeader
   */
  constructor() {
    super(store);
    this.unsubscribeStore = store.subscribe(() => this.mapProperties());
  }

  /**
   *
   * @memberof CdivHeader
   */
  mapProperties() {
    let state = store.getState().mainHeader;
    this.headerLogoRedirect = state.headerLogoRedirect;
  }

  /**
   *
   * @memberof CdivHeader
   */
  connectedCallback() {
    super.connectedCallback();
    this.setHeaderLogoRedirect();
    let headerLogoRedirect = store.getState().mainHeader.headerLogoRedirect;
    if (headerLogoRedirect) {
      this.$['abc-logo-link'].setAttribute('data-link-name', `${this.dataLinkName}:header:abcmouse logo`);
      this.$['abc-logo-link'].setAttribute('href', '/abc/homepage');
    }
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CdivHeader
   */
  static get is() {
    return 'cdiv-header';
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CdivHeader
   */
  static get properties() {
    return {
      dataLinkName: {
        type: String,
        value: ''
      }
    };
  }

  /**
   *
   * @memberof CdivHeader
   */
  setHeaderLogoRedirect() {
    store.commit([
      {
        stateAlias: 'mainHeader',
        mutationId: 'setHeaderLogoRedirect'
      }
    ]);
  }
}

window.customElements.define(CdivHeader.is, CdivHeader);



// WEBPACK FOOTER //
// ./cdiv/en-US/js/cdiv-header/cdiv-header.js